import React, { memo } from 'react';
import { CardkeeperLogo } from './CardkeeperLogo';
import { usePostHog } from 'posthog-js/react';
export function HeroSection() {
  const posthog = usePostHog();
  const handleCTAClick = () => {
    posthog?.capture('cta_clicked', {
      location: 'hero',
      button_text: 'Get the iOS App'
    });
    document.getElementById('waitlist')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-[#FAF8F5] px-6 py-16 md:py-24 flex flex-col items-center text-center" data-id="element-109">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-110">
        <div className="mb-8 md:mb-12" data-id="element-111">
          <CardkeeperLogo size={120} showWordmark={true} data-id="element-112" />
        </div>

        <h1 className="font-['DM_Sans'] text-4xl md:text-5xl lg:text-6xl font-medium text-[#3A3A3A] leading-[1.15] mb-6 tracking-tight" data-id="element-113">
          Never throw away a holiday card again
        </h1>

        <p className="text-lg md:text-xl text-[#3A3A3A]/80 leading-relaxed max-w-2xl mb-10" data-id="element-114">
          Save and organize every card you receive—by family, over time—so the
          memories last forever.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-115">
          <a href="https://apps.apple.com/us/app/cardkeeper-holiday-cards/id6758354419" target="_blank" rel="noopener noreferrer" onClick={() => {
          posthog?.capture('cta_clicked', {
            location: 'hero',
            button_text: 'Download on the App Store'
          });
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'Lead', {
              content_name: 'App Store Click',
              content_category: 'Hero CTA'
            });
          }
        }} className="inline-block hover:opacity-90 transition-opacity active:scale-95" data-id="element-116">
            <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" className="h-[52px] w-auto" data-id="element-117" />
          </a>
          <span className="text-[#B8A99A] text-sm font-medium tracking-wide" data-id="element-118">
            Available now on iOS
          </span>
        </div>
      </div>
    </section>;
}